
export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const splitIntoFlatChunks = (base64, keyPrefix) => {
  const CHUNK_SIZE = 20000;
  const chunks = {};
  let index = 1;

  for (let i = 0; i < base64.length; i += CHUNK_SIZE) {
    chunks[`${keyPrefix}${index}`] = base64.slice(i, i + CHUNK_SIZE);
    index++;
  }

  return chunks;
};
